import React, { Suspense, useLayoutEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { FloatingTree } from '@floating-ui/react';

import '@ecp/common/src/assets/css/default.css';

import defaultTheme from '@ecp/common/src/style/theme/default';

import RecoilExternalStatePortal from '@bo-recoil/RecoilExternalStatePortal';
import LoadingSpinner from '@bo-components/common/LoadingSpinner';
import ToastProvider from '@bo-components/common/provider/ToastProvider';
import SuspenseSpinner from '@bo-components/common/SuspenseSpinner';
import InvisibleLoading from '@bo-components/common/InvisibleLoading';
import routes from './routes/Routes';
import PoRoutes from './routes/PoRoutes';
import CoRoutes from './routes/CoRoutes';
import { isPODomain, isCODomain } from '@bo-const/common/domain';
import './App.css';
import './ibSheet/config';

function App() {
  useLayoutEffect(() => {
    if (isPODomain()) document.title = '웰스토리몰 파트너 ADMIN';
    else if (isCODomain()) document.title = '웰스토리몰 클라이언트 ADMIN';
    else document.title = '웰스토리몰 관리자 ADMIN';
  }, []);

  return (
    <React.StrictMode>
      <RecoilRoot>
        <ThemeProvider theme={defaultTheme}>
          <Suspense fallback={<SuspenseSpinner />}>
            <FloatingTree>
              <DndProvider backend={HTML5Backend}>
                {isCODomain() && <RouterProvider router={CoRoutes}></RouterProvider>}
                {isPODomain() && <RouterProvider router={PoRoutes}></RouterProvider>}
                {!isPODomain() && !isCODomain() && <RouterProvider router={routes}></RouterProvider>}
              </DndProvider>
            </FloatingTree>
            <InvisibleLoading />
            <LoadingSpinner />
            <ToastProvider />
          </Suspense>
          <RecoilExternalStatePortal />
        </ThemeProvider>
      </RecoilRoot>
    </React.StrictMode>
  );
}

export default App;
